import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import './i18n'

import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { createRoot } from 'react-dom/client'

import App from './App'
import reduxStore from './redux/store'

const { store, persistor } = reduxStore
const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
)
